





























































































































































































































































































import mixins from 'vue-typed-mixins'
import DraftActions from '@/builder/mixins/DraftActions'
import { DraftActionsType } from '@/calendesk/models/DraftActionsType'
import { DraftConfigurationType } from '@/calendesk/models/BuilderTypes'
import PlanActions from '@/builder/mixins/PlanActions'
import { DraftConfiguration } from '@/calendesk/models/DraftConfiguration'
import { BuilderSelectType } from '@/calendesk/models/BuilderSelectType'
import DefaultLanguages from '@/calendesk/models/DefaultLanguages'
import { WebsiteLanguageType } from '@/calendesk/models/WebsiteLanguageType'
import CalendeskInformationMessage from '@/lib/calendesk-js-library/components/CalendeskInformationMessage.vue'
import SettingTooltip from '@/components/Tools/SettingTooltip.vue'
import getLanguageName from '@/calendesk/tools/getLanguageName'
import { panelsToOpen, rememberOpenPanels } from '@/builder/sidebar/settingGroupState'

export default mixins(DraftActions, PlanActions).extend({
  name: 'General',
  components: { CalendeskInformationMessage, SettingTooltip },
  data () {
    return {
      googleTagIdEnabled: false,
      // Every group starts collapsed, so the tab opens as a list of group
      // names that fits the 360px drawer without scrolling. Groups the user
      // has opened or collapsed before keep that state.
      openPanels: [] as Array<number>,
      panelsRestored: false,
      groupIds: [
        'general:website',
        'general:booking',
        'general:client_account',
        'general:header_footer',
        'general:advanced'
      ],
      groups: {
        website: [
          'wb_primary_language__select__',
          'wb_favicon_url__text__',
          'wb_website_description__long_text__'
        ],
        booking: [
          'wb_hide_booking_employees__checkbox__',
          'wb_hide_booking_time_to__checkbox__',
          'wb_hide_time_zone__checkbox__',
          'wb_enable_discounts__checkbox__',
          'wb_hide_booking_prices__checkbox__'
        ],
        clientAccount: [
          'wb_hide_login__checkbox__',
          'wb_hide_signup__checkbox__',
          'wb_hide_payments__checkbox__',
          'wb_hide_profile_billing_data__checkbox__',
          'wb_hide_profile_photo_upload__checkbox__'
        ],
        headerFooter: [
          'wb_hide_header__checkbox__',
          'wb_hide_footer__checkbox__'
        ]
      },
      tools: [
        DraftConfigurationType.SELECT,
        DraftConfigurationType.TEXT,
        DraftConfigurationType.LONG_TEXT,
        DraftConfigurationType.CHECKBOX
      ],
      mode: DraftActionsType.CONFIGURATION,
      draftConfigurationType: DraftConfigurationType
    }
  },
  watch: {
    openPanels (indexes: Array<number>) {
      // The state restored in created() is not a choice the user made, so it
      // must not be written back as one: that would freeze today's default
      // for everyone who ever opened this tab.
      if (this.panelsRestored) {
        rememberOpenPanels(this.groupIds, indexes)
      }

      this.panelsRestored = true
    }
  },
  created () {
    this.googleTagIdEnabled = this.googleTagAvailable
    this.openPanels = panelsToOpen(this.groupIds, { filtering: false })
  },
  methods: {
    configsForGroup (keys: Array<string>): Array<DraftConfiguration> {
      return keys
        .map((key: string) => this.configuration.find((config: DraftConfiguration) => config.key === key))
        .filter(Boolean) as Array<DraftConfiguration>
    },
    getItemsForSelectType (type: BuilderSelectType): Array<Record<string, number | string>> {
      switch (type) {
        case BuilderSelectType.LANGUAGE:
          return DefaultLanguages()
      }

      return []
    },
    getTitleForSelectType (type: BuilderSelectType): string | null {
      switch (type) {
        case BuilderSelectType.LANGUAGE:
          return this.$trans('c_language_select_label')
      }

      return null
    },
    getObjectForSelectTypeAndValue (type: BuilderSelectType, value: WebsiteLanguageType | string): Record<string, any> | string | null {
      switch (type) {
        case BuilderSelectType.LANGUAGE:
          return {
            text: getLanguageName(value as WebsiteLanguageType),
            value
          }
      }

      return null
    },
    updateCheckboxValue (config: DraftConfiguration) {
      const protectedSections = [
        'wb_hide_header__checkbox__',
        'wb_hide_footer__checkbox__',
        'wb_hide_time_zone__checkbox__'
      ]

      if (protectedSections.includes(config.key) && !this.hideSectionsAvailable) {
        this.openFeatureNotAvailableDialog()
      } else {
        this.updateConfigurationProperty(config.key, config.value, true)
      }
    },
    updateGeneralConfigurationPropertyForSelect (key: string, value: any, selected: any) {
      value.value = selected.value
      this.$store.dispatch('setup/updateLanguage', value.value, { root: true }).then(() => {
        this.updateConfigurationPropertyForSelect(key, value, selected)
      })
    },
    updateCustomCode (value: string) {
      this.updateConfigurationProperty('wb_custom_code__long_text__', value)
    }
  }
})
